import React from 'react';

export const InfoText: React.FC<{ heading: string; text: string | number }> = ({
  text,
  heading
}) => {
  return (
    <div className={'d-flex flex-column'}>
      <span
        style={{
          color: '#A5B7BF'
        }}>
        {heading}
      </span>
      <span className={'fw-bold'}>{text}</span>
    </div>
  );
};
